import React, { useEffect } from "react";

const modalStyles = {
  backdrop: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff",
    padding: "1.5rem",
    borderRadius: "0.5rem",
    minWidth: "300px",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    textAlign: "center",
    position: "relative",
  },
  button: {
    marginTop: "1rem",
    padding: "0.5rem 1.25rem",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
  },
};

const AlertModal = ({ isOpen, message, onClose }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div style={modalStyles.backdrop}>
      <div style={modalStyles.modal}>
        <p>{message}</p>
        <button style={modalStyles.button} onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default AlertModal;
